import React from "react";
import HeaderPanel from "../../components/layout/HeaderPanel";
import { ConfigurationsPane } from "../../components/configuration/ConfigurationsPane";
import { formatMessage } from "../../utils/helpers/LanguageHelper";

export const SettingsPage: React.FunctionComponent = () => {
  return (
    <>
      <HeaderPanel applyPadding>{formatMessage("cof.access.configuration")}</HeaderPanel>
      <ConfigurationsPane />
    </>
  );
};
